/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAttributionClickFromJSON, ApiAttributionClickToJSON, } from './ApiAttributionClick';
import { ApiAudienceFromJSON, ApiAudienceToJSON, } from './ApiAudience';
import { ApiDataFromJSON, ApiDataToJSON, } from './ApiData';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiLeadConversionFromJSON, ApiLeadConversionToJSON, } from './ApiLeadConversion';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiSessionStatusFromJSON, ApiSessionStatusToJSON, } from './ApiSessionStatus';
import { ApiSourceFromJSON, ApiSourceToJSON, } from './ApiSource';
export function ApiSessionFromJSON(json) {
    return ApiSessionFromJSONTyped(json, false);
}
export function ApiSessionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'attributionClicks': !exists(json, 'attributionClicks') ? undefined : (json['attributionClicks'].map(ApiAttributionClickFromJSON)),
        'audiences': !exists(json, 'audiences') ? undefined : (json['audiences'].map(ApiAudienceFromJSON)),
        'conversions': !exists(json, 'conversions') ? undefined : (json['conversions'].map(ApiLeadConversionFromJSON)),
        'crawlerId': !exists(json, 'crawlerId') ? undefined : json['crawlerId'],
        'data': !exists(json, 'data') ? undefined : (json['data'].map(ApiDataFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
        'landingPage': !exists(json, 'landingPage') ? undefined : ApiDataFromJSON(json['landingPage']),
        'landingPageId': !exists(json, 'landingPageId') ? undefined : json['landingPageId'],
        'lead': !exists(json, 'lead') ? undefined : ApiLeadFromJSON(json['lead']),
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'sessionEnd': !exists(json, 'sessionEnd') ? undefined : (new Date(json['sessionEnd'])),
        'sessionStart': !exists(json, 'sessionStart') ? undefined : (new Date(json['sessionStart'])),
        'source': !exists(json, 'source') ? undefined : ApiSourceFromJSON(json['source']),
        'sourceId': !exists(json, 'sourceId') ? undefined : json['sourceId'],
        'status': !exists(json, 'status') ? undefined : ApiSessionStatusFromJSON(json['status']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiSessionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'analyticsSynced': value.analyticsSynced,
        'attributionClicks': value.attributionClicks === undefined ? undefined : (value.attributionClicks.map(ApiAttributionClickToJSON)),
        'audiences': value.audiences === undefined ? undefined : (value.audiences.map(ApiAudienceToJSON)),
        'conversions': value.conversions === undefined ? undefined : (value.conversions.map(ApiLeadConversionToJSON)),
        'crawlerId': value.crawlerId,
        'data': value.data === undefined ? undefined : (value.data.map(ApiDataToJSON)),
        'id': value.id,
        'isEffective': value.isEffective,
        'landingPage': ApiDataToJSON(value.landingPage),
        'landingPageId': value.landingPageId,
        'lead': ApiLeadToJSON(value.lead),
        'leadId': value.leadId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'sessionEnd': value.sessionEnd === undefined ? undefined : (value.sessionEnd.toISOString()),
        'sessionStart': value.sessionStart === undefined ? undefined : (value.sessionStart.toISOString()),
        'source': ApiSourceToJSON(value.source),
        'sourceId': value.sourceId,
        'status': ApiSessionStatusToJSON(value.status),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
